import React from 'react';
export function IntroSection() {
  return <section className="bg-white py-[140px] px-8 overflow-hidden" data-id="element-125">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start gap-16" data-id="element-126">
        {/* Left Content */}
        <div className="lg:w-[60%] section-reveal" data-id="element-127">
          <span className="block font-optima font-light text-[14px] uppercase text-gold tracking-[0.15em] mb-6" data-id="element-128">
            Introducing Glenlofty
          </span>
          <h2 className="font-optima font-semibold text-[36px] md:text-[48px] lg:text-[64px] text-charcoal leading-[1.15] mb-8" data-id="element-129">
            A New Expression of Victoria's Cool-Climate Pyrenees
          </h2>
          <p className="font-optima text-[20px] text-charcoal/90 leading-[1.8] max-w-2xl" data-id="element-130">
            The story of Glenlofty is etched into the ancient soils of the
            Pyrenees. Our land's agricultural heritage dates back to 1839, a
            legacy of pioneering spirit that we honor in our approach to
            viticulture.
          </p>
        </div>

        {/* Right Content - Abstract Botanical Graphic */}
        <div className="lg:w-[40%] flex justify-center lg:justify-end section-reveal stagger-1" data-id="element-131">
          <div className="relative w-[300px] h-[300px] opacity-80" data-id="element-132">
            <svg viewBox="0 0 200 200" className="w-full h-full text-gold/20 fill-current" data-id="element-133">
              <path d="M100,20 C60,20 20,60 20,100 C20,140 60,180 100,180 C140,180 180,140 180,100" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-134" />
              <path d="M100,20 C120,60 120,140 100,180" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-135" />
              <path d="M100,20 C80,60 80,140 100,180" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-136" />
              <path d="M20,100 C60,80 140,80 180,100" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-137" />
              <path d="M20,100 C60,120 140,120 180,100" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-138" />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-139">
              <div className="w-[1px] h-[150px] bg-charcoal/10 rotate-45" data-id="element-140"></div>
              <div className="w-[1px] h-[150px] bg-charcoal/10 -rotate-45" data-id="element-141"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}